import SubjectsFilter from './SubjectsFilter.react';

export default SubjectsFilter;
